import { apiGet, apiPost } from '../apiService';

export const fetchProductSummary = async (userId) => {
  try {
    return await apiGet(`api/product-summary/${userId}`);
  } catch (error) {
    throw new Error("Failed to fetch product summary");
  }
};

export const handleSaveSummary = async (userId, summaryData) => {
  try {
    return await apiPost(`api/product-summary/${userId}`, summaryData);
  } catch (error) {
    throw new Error("Failed to save product summary");
  }
};

export default { fetchProductSummary, handleSaveSummary };
